export default "__VITE_ASSET__DmMb1x3J__"